import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store.js'
import HelloWorld from '@/components/HelloWorld'
// import main from '@/components/main'
import home from '@/components/home'
import rules from '@/components/rules'
import rank from '@/components/rank'
import manager from '@/components/manager'
import signup from '@/components/signup'
import personal from '@/components/personal'
import rankdetail from '@/components/rankdetail'
import news from '@/components/news'
import newsdetail from '@/components/newsdetail'
import prevRank from '@/components/prevRank'
import prevdetail from '@/components/prevdetail'
import bluefile from '@/components/bluefile'

Vue.use(Router)

var router = new Router({
  routes: [
    {
      path: '*',
      name: 'home',
      component: home
  }, 
    {
      path: '/',
      name: 'home',
      component: home
    }, {
      path: '/rules',
      name: 'rules',
      component: rules
    }, {
      path: '/rank',
      name: 'rank',
      component: rank
    }, {
      path: '/rankdetail',
      name: 'rankdetail',
      component: rankdetail
    }, {
      path: '/manager',
      name: 'manager',
      component: manager
    }, {
      path: '/news',
      name: 'news',
      component: news
    }, , {
      path: '/newsdetail',
      name: 'newsdetail',
      component: newsdetail
    }, {
      path: '/signup',
      name: 'signup',
      component: signup
    }, {
      path: '/personal',
      name: 'personal',
      component: personal
    }, {
      path: '/prevRank',
      name: 'prevRank',
      component: prevRank
    }, {
      path: '/prevdetail',
      name: 'prevdetail',
      component: prevdetail
    }, {
      path: '/bluefile',
      name: 'bluefile',
      component: bluefile
    }
  ]
})

router.afterEach((to, from, next) => {

  if (to.name == '' || to.name == 'home') {
    store.state.active = 'sy'
  }else if (to.name == 'rules') {
    store.state.active = 'xz'
  }else if (to.name == 'rank') {
    store.state.active = 'ph'
  }else if (to.name == 'news') {
    store.state.active = 'gg'
  }else if (to.name == 'prevRank') {
    store.state.active = 'sph'
  }else if (to.name == 'manager') {
    store.state.active = 'bm'
  }else if (to.name == 'personal') {
    store.state.active = 'per'
  }else {
    store.state.active = ''
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js